// Lightweight Google Analytics 4 (GA4) helper.
// Measurement ID comes from REACT_APP_GA_MEASUREMENT_ID. If absent, all calls no-op.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function initAnalytics() {
  if (!GA_ID || typeof window === "undefined" || window.__gaInitialized) return;
  window.__gaInitialized = true;

  // gtag is normally installed statically in index.html. If it's already
  // present, don't inject a second loader/config.
  if (typeof window.gtag === "function") return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID);
}

export function trackEvent(action, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", action, params);
}

// Fired when a primary call-to-action is clicked.
export function trackCTA(label, location) {
  trackEvent("cta_click", { cta_label: label, cta_location: location });
}

// Form funnel events — compare which form converts best.
export function trackFormStart(formId) {
  trackEvent("form_start", { form_id: formId });
}

export function trackFormSubmit(formId) {
  trackEvent("form_submit", { form_id: formId });
}
